import { InMemoryCache, createHttpLink, ApolloClient, ApolloProvider } from '@apollo/client';
export { useLazyQuery, useMutation, useQuery, useSubscription } from '@apollo/client';
export { MockedProvider } from '@apollo/client/testing';
import { withAuthenticationRequired, useAuth0, Auth0Provider } from '@auth0/auth0-react';
export { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { setContext } from '@apollo/client/link/context';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

const APOLLO_CACHE = new InMemoryCache();
const ProtectedApolloClient = ({ apiUrl, children }) => {
    const { getAccessTokenSilently } = useAuth0();
    const apolloLink = createHttpLink({ uri: apiUrl });
    const apolloAuth0Link = setContext(() => __awaiter(void 0, void 0, void 0, function* () {
        const token = yield getAccessTokenSilently();
        return {
            headers: {
                Authorization: token,
            },
        };
    }));
    const apolloClient = new ApolloClient({
        link: apolloAuth0Link.concat(apolloLink),
        cache: APOLLO_CACHE,
    });
    return React.createElement(ApolloProvider, { client: apolloClient }, children);
};
var ProtectedApolloClient$1 = withAuthenticationRequired(ProtectedApolloClient);

const thirdPartyCookieError = typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    !navigator.cookieEnabled &&
    window.self !== window.top;
const ProtectedApiProvider = ({ auth0Domain, auth0ClientId, audience, auth0CacheLocation = "localstorage", redirectUri, onRedirectCallback, maxAge, useRefreshTokens = false, apiUrl, children, errorNode, }) => {
    return thirdPartyCookieError ? (errorNode) : (React.createElement(Auth0Provider, { domain: auth0Domain, clientId: auth0ClientId, redirectUri: redirectUri, audience: audience, onRedirectCallback: onRedirectCallback, cacheLocation: auth0CacheLocation, maxAge: maxAge, useRefreshTokens: useRefreshTokens },
        React.createElement(ProtectedApolloClient$1, { apiUrl: apiUrl }, children)));
};

export { ProtectedApiProvider };
